import { ComponentProps, useEffect, useRef } from 'react';
import { getDefaultClassNames, type DayButton } from 'react-day-picker';

import { Button } from '@/components/common';
import { mergeClasses } from '@/utils';

export const CalendarDayButton = ({
  className,
  day,
  modifiers,
  ...props
}: ComponentProps<typeof DayButton>) => {
  const defaultClassNames = getDefaultClassNames();

  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (modifiers.focused) ref.current?.focus();
  }, [modifiers.focused]);

  return (
    <Button
      ref={ref}
      size="sm"
      buttonColor="primary"
      buttonStyle="outline"
      data-day={day.date.toLocaleDateString()}
      data-selected-single={
        modifiers.selected &&
        !modifiers.range_start &&
        !modifiers.range_end &&
        !modifiers.range_middle
      }
      data-range-start={modifiers.range_start}
      data-range-end={modifiers.range_end}
      data-range-middle={modifiers.range_middle}
      className={mergeClasses(
        '!text-sm text-primary-darkest !font-medium border-none !size-[36px] hover:bg-neutral-3 dark:hover:bg-primary-base hover:shadow-none active:shadow-none focus:shadow-none focus:!ring-0 focus:!outline-none focus-visible:!ring-0 focus-visible:!outline-none data-[selected-single=true]:bg-primary-base dark:data-[selected-single=true]:bg-primary-base data-[selected-single=true]:text-neutral-0 data-[range-middle=true]:bg-neutral-3 data-[range-middle=true]:text-primary-darkest data-[range-start=true]:bg-primary-base data-[range-start=true]:text-neutral-0 data-[range-end=true]:bg-primary-base dark:data-[range-end=true]:bg-primary-base data-[range-end=true]:text-neutral-0 flex aspect-square w-full h-9 min-w-(--cell-size) flex-col gap-1 leading-none data-[range-end=true]:rounded-rounded data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-rounded [&>span]:text-xs',
        defaultClassNames.day,
        className,
      )}
      {...props}
    />
  );
};
